import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-muggle-murders-rise_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-muggle-murders-rise-grade-b",
  name: "The Quibbler v1 - Muggle Murders Rise (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "Muggle Murders Rise",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
